/**
 * Client-only correlation for fluxo 2.1, 3ª pergunta (notes/21367-mapeamento-
 * fluxos-relatorios.html): did the client open the creation form (fluxo 1.1)
 * and submit the SAME term they just searched for in the report list, right
 * after that search came back with zero results?
 *
 * The searched term itself must never reach telemetry (Req 12.10) — so the
 * comparison happens entirely in memory here, and only the boolean outcome
 * (`report_list_search_to_creation` firing or not) is ever emitted.
 */

const CORRELATION_WINDOW_MS = 2 * 60 * 1000;

let lastZeroResultSearch: { normalized: string; at: number } | null = null;

function normalize(term: string): string {
  return term.trim().toLowerCase();
}

/** Records a list search that returned zero results, for a short window. */
export function recordZeroResultListSearch(term: string): void {
  lastZeroResultSearch = { normalized: normalize(term), at: Date.now() };
}

/**
 * Checks `value` (the term just submitted in the creation form) against the
 * last recorded zero-result list search. Always consumes the recorded search
 * — a match or a miss, either way there is nothing left to compare against
 * for the next call, so a stale search can never match twice.
 */
export function consumeSearchToCreationMatch(value: string): boolean {
  const recorded = lastZeroResultSearch;
  lastZeroResultSearch = null;
  if (!recorded) return false;
  if (Date.now() - recorded.at > CORRELATION_WINDOW_MS) return false;
  return normalize(value) === recorded.normalized;
}
